import { Outlet, useNavigate } from 'react-router-dom'

import s from './Audience.module.scss'

import AudienceCard from './components/AudienceCard'

import { usePagination } from 'hooks/usePagination'

import { audienceApi } from 'api/audience-api'

import users from 'assets/svg/icons-audience.svg'

import { CustomButton } from 'components/UI/CustomButton/CustomButton'
import Header from 'components/UI/Header'
import { NoContent } from 'components/UI/NoContent/NoContent'
import PageTitle from 'components/UI/PageTitle'
import Search from 'components/UI/Search'

const Audience = () => {
  const navigate = useNavigate()
  const {
    data: templates,
    loading,
    totalElements,
    paging,
    handleDelete,
    deleteLoading,
  } = usePagination({
    getData: audienceApi.paging,
    deleteData: audienceApi.delete,
  })

  const title = paging?.quick_search?.length
    ? templates?.length
      ? 'Found Templates'
      : 'Nothing found'
    : templates?.length
    ? 'My Templates'
    : null

  return (
    <>
      <Outlet />
      <Header>
        <div className={s.controlsWrapper}>
          <CustomButton variant="secondary" onClick={() => navigate('create')} size="240" className={s.button}>
            New template
          </CustomButton>
          <Search paramPrefix="audience" className={s.search} />
        </div>
        <PageTitle title={title} count={totalElements} color="secondary" loading={loading || deleteLoading} />
      </Header>
      <main>
        {templates?.length ? (
          <div className={s.cardsWrapper}>
            {templates.map((template) => (
              <AudienceCard key={template.id} item={template} deleteItem={handleDelete} />
            ))}
          </div>
        ) : !paging?.quick_search?.length && !loading ? (
          <NoContent icon={users} title="No Templates" subtitle="You haven’t created any templates yet." />
        ) : null}
      </main>
    </>
  )
}

export default Audience
